import PreferenceDispenserColorsModel from "@/common/models/PreferenceDispenserColorsModel";

export default class DispenserColorThemeModel extends PreferenceDispenserColorsModel {
    name: string = "";

    static from(json: any): DispenserColorThemeModel {
        let model = Object.assign(new DispenserColorThemeModel(), json);
        return model;
    }
}
